export enum GeneratedDocumentAdditionalClassification {
  Allergies = 'allergies',
  FamilyHistory = 'family_history',
  SocialHistory = 'social_history',
  Vaccinations = 'vaccinations',
  AdditionalReferenceDocuments = 'additional_reference_documents',
  Providers = 'providers',
}
